import { render, staticRenderFns } from "./permitManage.vue?vue&type=template&id=31ec803d&scoped=true"
import script from "./permitManage.vue?vue&type=script&lang=js"
export * from "./permitManage.vue?vue&type=script&lang=js"
import style0 from "./permitManage.vue?vue&type=style&index=0&id=31ec803d&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ec803d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31ec803d')) {
      api.createRecord('31ec803d', component.options)
    } else {
      api.reload('31ec803d', component.options)
    }
    module.hot.accept("./permitManage.vue?vue&type=template&id=31ec803d&scoped=true", function () {
      api.rerender('31ec803d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/auth/permitManage.vue"
export default component.exports